import componentRegistry from '../../components/registry.js';
import isIntersecting from '../../helpers/dom/isIntersecting.js';
import rejectNonOkResponse from '../../scripts/api/rejectNonOkResponse.js';
export default class LazyHTML {
  #loadCallback;
  #target;

  /**
   * @param {object} param0
   * @param {Element} param0.el
   * @param {function():Promise<any>} [param0.load] Function called when load happened. Enable additional wait of async
   *   task (other than the load of the source itself)
   * @see https://github.com/github/include-fragment-element
   */
  constructor({ el, load = () => Promise.resolve() }) {
    this.el = el;
    const isProductPage = this.el.closest('.f-productPage') !== null;
    const launchContainer = document.querySelector('.js-stickyHeader');
    this.#loadCallback = load;
    this.#target = isProductPage ? launchContainer : this.el;
    isIntersecting(this.#target).then(() => this.#load());
  }

  #load = async () => {
    const { src } = this.el.dataset;
    try {
      const [html] = await Promise.all([rejectNonOkResponse(fetch(src)).then((r) => r.text()), this.#loadCallback?.()]);
      this.el.innerHTML = html;
      this.el.dispatchEvent(new Event('load', { bubbles: true }));
    } catch {
      this.el.innerHTML = '<!-- Error -->';
      this.el.dispatchEvent(new Event('error', { bubbles: true }));
    }
  };
}

componentRegistry.define('js-lazy-html', LazyHTML);
